/* eslint-disable */
import React, { PropTypes } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactModal from 'react-modal';
import Alert from 'react-s-alert';
import * as campanhaActions from './actions/campanhaActions'
import RatingPerguntaForm from './RatingPerguntaForm'
import RatingEmoji from './RatingEmoji'
import RatingStar from './RatingStar'
import RatingNps from './RatingNps'
import Helpers from './util/Helpers'
import ConfigD from './util/ConfigD';
import './css/Rating.css'
import './css/modal.css'
import Erro from './Erro';


//CSS para radio
//https://gist.github.com/rcotrina94/7828886
class RatingForm extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            imagemSelecionada:'',
            textoImgSelecionada:'',
            imagemClicada:'',
            showModal: false,
            txtMensagem:'',
            reiniciarPagina:false,
            token: !$.isEmptyObject(this.props.params) && this.props.params.token ? this.props.params.token : null,
            erro:null,
            tipoCampanha: !$.isEmptyObject(this.props.params) && this.props.params.tipo ? this.props.params.tipo : '1',
            idCampanha: !$.isEmptyObject(this.props.params) && this.props.params.idCampanha ? this.props.params.idCampanha : null,
            perguntaCampanha:null,
            campanhaAtiva:null
        }
        this.clickImg = this.clickImg.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.reiniciarPagina = this.reiniciarPagina.bind(this);
        this.onChangeTxtMensagem = this.onChangeTxtMensagem.bind(this);
        this.cadastrar = this.cadastrar.bind(this);
        this.validaForm = this.validaForm.bind(this);
        this.gerenciarCampanha = this.gerenciarCampanha.bind(this);
      }
      
      validaForm() {
        
        var valido = true;
       
        var mensagem = this.refs.txtMensagem.value;
        
        if (this.state.imagemClicada === '') {
            $(this.refs.errMensagem).show();
            valido = false;
        }

        return valido;
    }

      
    cadastrar(event){
        if (event != undefined) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        if (this.validaForm()) {
            var campanha = {}
                campanha = Object.assign({}, this.state.campanhaAtiva);
                
                if(campanha.dado!=null && campanha.dado.mPerguntas!==null && campanha.dado.mRespostas!==null){
                    for (let index = 0; index < campanha.dado.mRespostas.length; index++) {
                        const resposta = campanha.dado.mRespostas[index];
                            resposta.mObservacao = this.state.txtMensagem;
                        }
                    }
            }
            var data = {campanha: campanha.dado};
            
            this.props.actions.gravar(data).then( this.handleOpenModal()).catch(error => {
                
                Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                    position: 'top-right',
                    effect: 'slide',
                    offset: 172,
                    timeout: 5000
                });
            });;
    }

    handleOpenModal () {
        
        if(this.state.token===null){
            this.setState({ showModal: true });
            var self = this;
            setTimeout(function(){self.handleCloseModal()}, 3000);
        }
        else{
            this.setState({erro: 'Obrigado pela participação'});
        }
    }
    
    handleCloseModal () {
    
        if(this.state.showModal === true){
            this.setState({ showModal: false });
            this.reiniciarPagina();
            this.gerenciarCampanha();
        }
    }

    onChangeTxtMensagem(e){
        this.setState({txtMensagem:e.target.value});
    }
    
    reiniciarPagina () {
        this.setState({ 
            imagemSelecionada:'', 
            imagemClicada:'',
            textoImgSelecionada:'',
            txtMensagem:'',
            reiniciarPagina:true
        });
    }

    clickImg(val, perguntaRespondida){
        
        $(this.refs.errMensagem).hide();
        this.setState({reiniciarPagina:false})
        this.setState({imagemSelecionada:val, imagemClicada:val, textoImgSelecionada:this.state.tipoCampanha==='1'?'Nota: '+val:Helpers.obteTextoEmoji(val)});
        
        var campanha = Object.assign({}, this.state.campanhaAtiva);
        
        if(campanha.dado!=null && campanha.dado.mPerguntas!==null && campanha.dado.mRespostas!==null){
            for (let index = 0; index < campanha.dado.mRespostas.length; index++) {
                const resposta = campanha.dado.mRespostas[index];
                if(resposta.mPergunta.mIdCampanhaPergunta == perguntaRespondida.mIdCampanhaPergunta){
                    resposta.mNota = val;
                    resposta.mObservacao = this.state.txtMensagem;
                    break;
                }
            }
            this.setState({campanhaAtiva:campanha});
        }
        //console.log('campanha com pergunta respondida ', val, campanha )
    }

    gerenciarCampanha(){
        
        if(this.state.token!==null){
            //console.log('token', this.state.token)
            var token= {
                token : this.state.token
            }

            this.props.actions.obterCampanhaPorToken(token).catch(error => {
                
                this.setState({erro: !$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText})
            });;
        }else{
            //console.log('idcampanha', this.state.idCampanha)
            var idCampanha= {
                idCampanha : this.state.idCampanha
            }
            Helpers.apresentarSpinner('Carregando campanha...');
            this.props.actions.obterCampanhaPorIdCampanha(idCampanha).then(()=>
            Helpers.removerSpinner()).catch(error => {
                
                this.setState({erro: !$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText})
            });;
        }

    }
    componentDidMount() {
        $('#header').hide();
        this.gerenciarCampanha();
 
    }
    componentWillReceiveProps(nextProps){
        if (!$.isEmptyObject(nextProps.campanha) && this.props.campanha !== nextProps.campanha) {
           //console.log('passou nextProps', nextProps.campanha);
           var campanha = JSON.parse(JSON.stringify(nextProps.campanha));
           //var campanha = Object.assign({}, nextProps.campanha);
           this.setState({campanhaAtiva:campanha});
        }
    }

    render() {
        if (!$.isEmptyObject(this.state.erro)){
            return <Erro mensagemErro={this.state.erro} />
        }
        if ($.isEmptyObject(this.props.campanha)){
            return <div/>
        }
        return (
            <div className="container">
                <form method="post" id='form' >
                    <div className="row">
                        <div className="divider"></div>
                        <div className="reasons">
                            <div className="col-lg-12 col-md-12 col-sm-12 animate_afc d1">
                                <div className="content-box big ch-item bottom-pad-small">
                                    <div className="ch-info-wrap">
                                        <div className="ch-info">
                                            <div className="ch-info-front ch-img-1"><i className="fa fa-question"></i></div>
                                            <div className="ch-info-back">
                                                <i className="fa fa-question"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content-box-info">
                                    </div>
                                    <div className="content-box-infoServico">
                                        <div className="divider"></div>
                                        {this.props.campanha.dado.mPerguntas.map((pergunta, index) =>
                                            <RatingPerguntaForm pergunta={pergunta} key={index}  clickImg={this.clickImg} reiniciarPagina={this.state.reiniciarPagina}/>
                                        )}

                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <div className="input-icon">
                                                    <label><b>Gostaria de detalhar melhor sobre as notas dadas?</b></label>
                                                    <div>
                                                        <textarea rows="6" cols="50" className="form-control" name="txtMensagem" id='txtMensagem' placeholder="" ref='txtMensagem' id='txtMensagem' name='txtMensagem' onChange={this.onChangeTxtMensagem} value={this.state.txtMensagem} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                    
                                        <div className='row central'>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <button type="submit" onClick={this.cadastrar}>Cadastrar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <ReactModal 
                        isOpen={this.state.showModal}
                        contentLabel="onRequestClose Example" 
                        onRequestClose={this.handleCloseModal}
                        className="Modal"
                        overlayClassName="Overlay"
                    >
                     <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className='row central'><br/>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h2><strong> Obrigado pela participação!</strong></h2>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <button onClick={this.handleCloseModal}>Fechar</button>
                            </div>
                     </div>
                     </div>
                    </ReactModal>
                </form>
            </div>

        );
    }
}
RatingForm.contextTypes = {
    router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    
    return {
        campanha: state.campanha
    };
}

function mapDispatchToProps(dispatch){
   return {
        
       actions: bindActionCreators(campanhaActions, dispatch)
    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(RatingForm);





/** WEBPACK FOOTER **
 ** ./src/components/RatingForm.js
 **/